import { render, staticRenderFns } from "./CategorySelectPool.vue?vue&type=template&id=4ed64231&scoped=true"
import script from "./CategorySelectPool.vue?vue&type=script&lang=js"
export * from "./CategorySelectPool.vue?vue&type=script&lang=js"
import style0 from "./CategorySelectPool.vue?vue&type=style&index=0&id=4ed64231&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed64231",
  null
  
)

export default component.exports